import React, {ReactNode} from 'react';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {DeviceType, RegionType} from '@shared/cci/features/const/environment';

export interface EnvironmentProps {
  children: ReactNode;
}

function EnvironmentRoot(): JSX.Element {
  // 일단 하는일 없음
  return <></>;
}

function Pc({children}: EnvironmentProps) {
  const {device, isWebview} = useEnvironmentStore(({device, isWebview}) => ({device, isWebview}));

  if (isWebview || device !== DeviceType.PC) {
    return null;
  }

  return <>{children}</>;
}

function Tablet({children}: EnvironmentProps) {
  const {device, isWebview} = useEnvironmentStore(({device, isWebview}) => ({device, isWebview}));

  if (isWebview || device !== DeviceType.TABLET) {
    return null;
  }

  return <>{children}</>;
}

function Mobile({children}: EnvironmentProps) {
  const {device, isWebview} = useEnvironmentStore(({device, isWebview}) => ({device, isWebview}));

  if (isWebview || device !== DeviceType.MOBILE) {
    return null;
  }

  return <>{children}</>;
}

function WebView({children}: EnvironmentProps) {
  const {isWebview} = useEnvironmentStore(({isWebview}) => ({isWebview}));

  if (!isWebview) {
    return null;
  }

  return <>{children}</>;
}

function Kr({children}: EnvironmentProps) {
  const {region} = useEnvironmentStore(({region}) => ({region}));

  if (region !== RegionType.KR) {
    return null;
  }

  return <>{children}</>;
}

function Eu({children}: EnvironmentProps) {
  const {region} = useEnvironmentStore(({region}) => ({region}));

  if (region !== RegionType.EU) {
    return null;
  }

  return <>{children}</>;
}

const Environment = Object.assign(EnvironmentRoot, {
  Kr,
  Eu,
  Pc,
  Tablet,
  Mobile,
  WebView,
});

export default Environment;
